import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../library/custom/table/table";
import {
  HBNEXT_ORG_ID,
  ORG_ID,
  PAGE_SIZE_100,
} from "../../../../constant/constant";
import {
  downloadExcel,
  downloadPDF,
  getFormatedDate,
  useInfiniteScroll,
} from "../../../../utils/helper";
import * as lmsReportAction from "../../../../redux/actions/lmsReportAction";
import { useLocation } from "react-router-dom";
import commonImages from "../../../../assets";
import { Popover } from "@mui/material";
import Loader from "../../../../library/common/Loader";
import { REPORTS_ANALYTICS_DASHBOARD } from "../../../../constant/routeContant";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import SearchIcon from "@mui/icons-material/Search";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import * as clientAction from "../../../../redux/actions/clientAction";
import "./scormcoursereportlist.scss";
import { PRODUCT_ID } from "../../../../constant/storm-water/constant";
import * as adminAction from "../../../../redux/actions/adminCommonAction";
import { Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip";
import NORow from "../../../../library/custom/noRow/noRow";

const ScormcourseReportList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const apiData = location?.state?.apiData;
  const scormReportResponse = useSelector(
    (state) => state.getLmsScormCourseReport?.data,
  );
  const scormReportResponseisLoading = useSelector(
    (state) => state.getLmsScormCourseReport?.isLoading,
  );
  const [data, setData] = useState([]);
  const [sortColumn, setSortColumn] = useState();
  const [sortDirection, setSortDirection] = useState("asc");
  const [page, setPage] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [IsScormCourseStatus, setIsScormCourseStatus] = useState("");
  const [filter, setFilter] = useState({
    searchType: [],
  });
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [anchorElFilter, setAnchorElFilter] = React.useState(null);
  const openFilter = Boolean(anchorElFilter);
  const idFilter = openFilter ? "simple-popover" : undefined;
  const allClients = useSelector((state) => state?.searchAllClientsReducerData);
  const isSearchClientLoading = allClients?.isLoading;
  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const dataResponse = useSelector((state) => state.getLmsScormCourseReport);
  const division = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons,
  );
  const [clients, setClients] = useState();
  const [divisionfilter, setDivisionFilter] = useState("");

  const dataBack = {
    title: "Back to Dashboard",
    route: REPORTS_ANALYTICS_DASHBOARD,
    state: {
      apiData,
      backpage: "backpage",
      tab: apiData?.tab,
    },
  };

  const fetchData = (pageNumber) => {
    const data = {
      page: pageNumber,
      pageSize: PAGE_SIZE_100,
      startDate: fromDate
        ? getFormatedDate(fromDate)
        : getFormatedDate(apiData?.startDate),
      endDate: toDate
        ? getFormatedDate(toDate)
        : getFormatedDate(apiData?.endDate),
      search: debouncedSearch,
      statusId: IsScormCourseStatus,
      DivisionId: divisionfilter,
      isSendMail: false,
      allClient: clients ? false : isShowClient ? true : false,
    };

    dispatch(lmsReportAction.getLmsScormCourseReport(data));
    setPage(pageNumber);
  };

  const handleSort = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    setSortColumn(column);
    setSortDirection(newDirection);

    const sortedData = [...data].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
  };

  const tableRef = useInfiniteScroll(() => {
    if (!scormReportResponseisLoading) {
      fetchData(page + 1);
    }
  }, [page, scormReportResponseisLoading]);

  const columns = [
    {
      id: "userName",
      label: "User Name",
      sortable: true,
      isSorted: sortColumn === "userName",
      sortDirection,
    },
    {
      id: "courseName",
      label: "Course Name",
      sortable: true,
      isSorted: sortColumn === "courseName",
      sortDirection,
    },
    {
      id: "status",
      label: "Status",
      sortable: true,
      isSorted: sortColumn === "status",
      sortDirection,
    },
    {
      id: "organisationId",
      label: "Client",
      sortable: true,
      isSorted: sortColumn === "organisationId",
      sortDirection,
    },
    {
      id: "divisions",
      label: "Division",
      sortable: true,
      isSorted: sortColumn === "divisions",
      sortDirection,
    },
    {
      id: "assignedOn",
      label: "Assigned On",
      sortable: true,
      isSorted: sortColumn === "assignedOn",
      sortDirection,
      className: "assignedOnDateScormDate",
    },
    {
      id: "startedOn",
      label: "InProgress On",
      sortable: true,
      isSorted: sortColumn === "startedOn",
      sortDirection,
      className: "assignedOnDateScormDate",
    },
    {
      id: "completedOn",
      label: "Completed On",
      sortable: true,
      isSorted: sortColumn === "completedOn",
      sortDirection,
      className: "assignedOnDateScormDate",
    },
    {
      id: "costPerSeat",
      label: "Cost per seat",
      sortable: true,
      isSorted: sortColumn === "costPerSeat",
      sortDirection,
    },
  ];
  const showClientColumn = checkPrivileges([12, 15]) && isShowClient;

  const renderDivisionWithTooltip = (divisions) => {
    if (!divisions) return "N/A";

    const divisionArray = divisions.split(",").map((d) => d.trim());

    if (divisionArray.length <= 2) {
      return divisionArray.join(", ");
    }

    const visible = divisionArray.slice(0, 2).join(", ");
    const remaining = divisionArray.length - 2;

    return (
      <Tooltip
        title={
          <div style={{ whiteSpace: "pre-line" }}>
            {divisionArray.join(", ")}
          </div>
        }
        placement="bottom-end"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "#ffffff",
              color: "#333333",
              fontSize: "12px",
              border: "1px solid",
              padding: "8px 12px",
              fontWeight: 400,
              fontFamily: "Lato",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            },
          },
          arrow: {
            sx: {
              color: "#ffffff",
            },
          },
        }}
      >
        <div className="textchange">
          <p>
            {" "}
            {visible} +{remaining}
          </p>
        </div>
      </Tooltip>
    );
  };

  const finalColumns = showClientColumn
    ? columns
    : columns.filter((col) => col.id !== "organisationId");
  const rows = useMemo(
    () =>
      data?.map((course, index) => (
        <tr className="row" key={index}>
          <td>{course?.userName}</td>
          <td>{course?.courseName}</td>
          <td>{course?.status}</td>
          {showClientColumn && <td>{course?.organisationName}</td>}
          <td>{renderDivisionWithTooltip(course?.divisions)}</td>

          <td>{course?.assignedOn || "N/A"}</td>
          <td>{course?.startedOn || "N/A"}</td>
          <td>{course?.completedOn || "N/A"}</td>
          <td>
            {course?.status === "Assigned"
              ? "$0"
              : course?.costPerSeat != null
                ? `$${course.costPerSeat}`
                : "N/A"}
          </td>
        </tr>
      )),
    [data, showClientColumn],
  );

  const rowsPdf = data?.map((course) => {
    const row = [course?.userName, course?.courseName, course?.status];

    if (showClientColumn) {
      row.push(course?.organisationName);
    }

    row.push(
      course?.divisions || "N/A",
      course?.assignedOn || "N/A",
      course?.startedOn || "N/A",
      course?.completedOn || "N/A",
      course?.status === "Assigned"
        ? "$0"
        : course?.costPerSeat != null
          ? `$${course.costPerSeat}`
          : "N/A",
    );

    return row;
  });

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event?.target?.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
  };

  const onchangeFromDatePicker = (e) => {
    setFromDate(e);
  };
  const onchangeToDatePicker = (e) => {
    setToDate(e);
  };

  const handleApply = () => {
    setPage(1);
    setData([]);

    const data = {
      page: 1,
      pageSize: PAGE_SIZE_100,
      startDate: fromDate
        ? getFormatedDate(fromDate)
        : getFormatedDate(apiData?.startDate),
      endDate: toDate
        ? getFormatedDate(toDate)
        : getFormatedDate(apiData?.endDate),
      search: debouncedSearch,
      isSendMail: false,
      statusId: IsScormCourseStatus,
      DivisionId: divisionfilter,
      allClient: clients ? false : isShowClient ? true : false,
    };
    handleSearch(data);
    setAnchorElFilter(null);
  };

  const handleClear = () => {
    setPage(1);
    setFromDate(null);
    setToDate(null);
    setSearch("");
    setIsScormCourseStatus("");
    setDivisionFilter("");
    setData([]);

    const data = {
      page: 1,
      pageSize: PAGE_SIZE_100,
      startDate: getFormatedDate(apiData?.startDate),
      endDate: getFormatedDate(apiData?.endDate),
      search: "",
      isSendMail: false,
      statusId: "",
      DivisionId: "",
      allClient: clients ? false : isShowClient ? true : false,
    };

    handleSearch(data);
  };
  const handleSearch = (data) => {
    setAnchorEl(null);
    dispatch(lmsReportAction.getLmsScormCourseReport(data));
  };
  const isScormCourseOnChanges = (e) => {
    setIsScormCourseStatus(e?.target?.value);
  };

  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  const typeOnchange = (event, value) => {
    searchClient(event?.target?.value);
  };
  const onChangeClients = (value) => {
    setClients(value);
  };

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: "1,6,12",
    productId: PRODUCT_ID(),
  };

  const downloadAllData = () => {
    setEmailSendStatus(true);
    const data = {
      page: 1,
      pageSize: PAGE_SIZE_100,
      startDate: fromDate
        ? getFormatedDate(fromDate)
        : getFormatedDate(apiData?.startDate),
      endDate: toDate
        ? getFormatedDate(toDate)
        : getFormatedDate(apiData?.endDate),
      search: debouncedSearch,
      statusId: IsScormCourseStatus,
      DivisionId: divisionfilter,
      isSendMail: true,
      allClient: clients ? false : isShowClient ? true : false,
    };
    if (data?.isSendMail) {
      setEmailSendStatus(true);
    } else {
      setEmailSendStatus(false);
    }

    dispatch(lmsReportAction.getLmsScormCourseReport(data));

    setAnchorEl(null);
    setTimeout(() => setEmailSendStatus(false), 3000);
  };
  useEffect(() => {
    setPage(1);
    setData([]);
    dispatch(
      lmsReportAction.getLmsScormCourseReport({
        page: 1,
        pageSize: PAGE_SIZE_100,
        startDate: fromDate
          ? getFormatedDate(fromDate)
          : getFormatedDate(apiData?.startDate),
        endDate: toDate
          ? getFormatedDate(toDate)
          : getFormatedDate(apiData?.endDate),
        search: debouncedSearch,
        isSendMail: false,
        statusId: IsScormCourseStatus,
        DivisionId: divisionfilter,
        allClient: clients ? false : isShowClient ? true : false,
      }),
    );
  }, [debouncedSearch]);

  useEffect(() => {
    if (scormReportResponse?.result?.length) {
      const mappedData = scormReportResponse.result.map((item) => ({
        ...item,
        status: item?.status,
      }));

      setData((prev) => (page === 1 ? mappedData : [...prev, ...mappedData]));
    }
  }, [scormReportResponse]);
  useEffect(() => {
    setData([]);
    dispatch(
      lmsReportAction.getLmsScormCourseReport({
        page: 1,
        pageSize: PAGE_SIZE_100,
        clients: clients,
        search: debouncedSearch,
        startDate: fromDate
          ? getFormatedDate(fromDate)
          : getFormatedDate(apiData?.startDate),
        endDate: toDate
          ? getFormatedDate(toDate)
          : getFormatedDate(apiData?.endDate),
        statusId: IsScormCourseStatus,
        isSendMail: false,
        DivisionId: divisionfilter,
        allClient: clients ? false : isShowClient ? true : false,
      }),
    );
  }, [clients]);
  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, [dispatch]);

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e.target.value);
  };
  const [emailSendStatus, setEmailSendStatus] = useState(null);
  useEffect(() => {
    if (dataResponse?.status === "SUCCESS" && emailSendStatus) {
      toast.success("Data has been sent to your email successfully!");
      setEmailSendStatus(false);
    }
  }, [dataResponse?.status, emailSendStatus]);
  return (
    <>
      <BackBtn dataBack={dataBack} />
      <ToastContainer position="top-right" />
      <Grid container xs={12} md={3}>
        <div className="title">Assign Scorm Courses</div>
      </Grid>
      <Grid
        container
        alignItems="center"
        spacing={2}
        className="topHeaderDrill"
      >
        <Grid item xs={12} lg={3.5}>
          {checkPrivileges([12, 15]) && isShowClient && (
            <SearchAutoComplete
              name="orgName"
              placeholderText="Search client"
              noOptionsTextMsg="No organization"
              optionsData={
                allClients?.data?.filter((user) => user.Status !== 0) ?? []
              }
              typeOnchange={(event, value) => typeOnchange(event, value)}
              isKeyValuePair
              value={clients}
              onChange={(event, value) => onChangeClients(value)}
              isLoading={isSearchClientLoading}
            />
          )}
        </Grid>

        <Grid item xs={12} lg={3.5}>
          <div className="searchcaseid scorm">
            <label htmlFor="search">
              <span>
                <SearchIcon />
              </span>
              <div>
                <input
                  id="search"
                  placeholder="Search user name"
                  type="text"
                  value={search}
                  onChange={handleautoSearch}
                  autoComplete="off"
                />
              </div>
            </label>
          </div>
        </Grid>

        {/* Filter */}
        <Grid item xs={12} lg={2}>
          <div className="filter_btn_lms_scrom">
            <button
              aria-describedby={idFilter}
              variant="contained"
              type="button"
              name="btn"
              onClick={(e) => handleClickFilter(e)}
            >
              <FilterListIcon id="icn" /> Filters
            </button>

            <FilterCommonStatusSelect
              open={openFilter}
              anchorEl={anchorElFilter}
              handleClose={handleCloseFilter}
              handleApply={handleApply}
              handleClear={handleClear}
              filter={filter}
              filterSelect={false}
              filterStatus={false}
              resetBtn
              filterDate
              toDate={toDate}
              fromDate={fromDate}
              onchangeToDatePicker={onchangeToDatePicker}
              onchangeFromDatePicker={onchangeFromDatePicker}
              filterIsCourseScormStatus
              isScormCourseOnChanges={isScormCourseOnChanges}
              IsScormCourseStatus={IsScormCourseStatus}
              isDivistionFilter={true}
              firstLebelFilter={division}
              firstLebelOnChanges={divisionFilterOnChanges}
              firstLebelValue={divisionfilter}
              disableDivision={showClientColumn}
            />
          </div>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <div
            className="downloadBoxScrom"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <div className="downloadIcon">
              <img src={commonImages?.downloadWhite} alt="Download" />
            </div>
            <div className="downloadText">Download Data</div>
          </div>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <div className="downloadListBox">
              <div className="downloadList">
                <div className="downloads">
                  <div
                    className="downloadListIcon"
                    onClick={() =>
                      downloadPDF(
                        rowsPdf,
                        finalColumns.map((col) => col.label),
                        "ScormCourses.pdf",
                      )
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.5 8.5H6.5V7H7C7.28333 7 7.52083 6.90417 7.7125 6.7125C7.90417 6.52083 8 6.28333 8 6V5.5C8 5.21667 7.90417 4.97917 7.7125 4.7875C7.52083 4.59583 7.28333 4.5 7 4.5H5.5V8.5ZM6.5 6V5.5H7V6H6.5ZM8.5 8.5H10C10.2833 8.5 10.5208 8.40417 10.7125 8.2125C10.9042 8.02083 11 7.78333 11 7.5V5.5C11 5.21667 10.9042 4.97917 10.7125 4.7875C10.5208 4.59583 10.2833 4.5 10 4.5H8.5V8.5ZM9.5 7.5V5.5H10V7.5H9.5ZM11.5 8.5H12.5V7H13.5V6H12.5V5.5H13.5V4.5H11.5V8.5ZM4.5 13C4.0875 13 3.73438 12.8531 3.44062 12.5594C3.14687 12.2656 3 11.9125 3 11.5V1.5C3 1.0875 3.14687 0.734376 3.44062 0.440626C3.73438 0.146876 4.0875 0 4.5 0H14.5C14.9125 0 15.2656 0.146876 15.5594 0.440626C15.8531 0.734376 16 1.0875 16 1.5V11.5C16 11.9125 15.8531 12.2656 15.5594 12.5594C15.2656 12.8531 14.9125 13 14.5 13H4.5ZM1.5 16C1.0875 16 0.734375 15.8531 0.440625 15.5594C0.146875 15.2656 0 14.9125 0 14.5V3H1.5V14.5H13V16H1.5Z"
                        fill="none"
                      />
                    </svg>
                    <span>Download PDF</span>
                  </div>
                </div>
              </div>
              <div className="downloadList">
                <div className="downloads">
                  <div
                    className="downloadListIcon"
                    onClick={() => downloadExcel(data, "ScormCourses.xlsx")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_6635_4490)">
                        <path
                          d="M9.22 0.0100392L0.26 1.71004C0.10875 1.73879 0 1.87629 0 2.03004V13.97C0 14.1238 0.10875 14.2613 0.26 14.29L9.22 15.99C9.24 15.9938 9.26 16 9.28 16C9.35375 16 9.4225 15.9775 9.48 15.93C9.55375 15.8688 9.6 15.775 9.6 15.68V0.320039C9.6 0.225039 9.55375 0.131289 9.48 0.0700392C9.40625 0.0087892 9.31375 -0.00746081 9.22 0.0100392ZM10.24 1.92004V4.16004H10.88V4.80004H10.24V6.40004H10.88V7.04004H10.24V8.64004H10.88V9.28004H10.24V11.2H10.88V11.84H10.24V14.08H15.04C15.3925 14.08 15.68 13.7925 15.68 13.44V2.56004C15.68 2.20754 15.3925 1.92004 15.04 1.92004H10.24ZM11.52 4.16004H14.08V4.80004H11.52V4.16004ZM2.14 5.02004H3.78L4.64 6.81004C4.7075 6.95129 4.7675 7.12504 4.82 7.32004H4.83C4.86375 7.20379 4.92875 7.02129 5.02 6.79004L5.97 5.02004H7.47L5.68 7.98004L7.52 11H5.93L4.89 9.05004C4.85125 8.97754 4.81125 8.84379 4.77 8.65004H4.76C4.74 8.74129 4.6925 8.88379 4.62 9.07004L3.58 11H1.98L3.89 8.01004L2.14 5.02004ZM11.52 6.40004H14.08V7.04004H11.52V6.40004ZM11.52 8.64004H14.08V9.28004H11.52V8.64004ZM11.52 11.2H14.08V11.84H11.52V11.2Z"
                          fill="none"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6635_4490">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Download .xlsx</span>
                  </div>
                </div>
              </div>
              <div className="downloadList">
                <div className="downloads">
                  <div className="downloadListIcon" onClick={downloadAllData}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M2 13.5V11H3.5V13.5H12.5V11H14V13.5C14 13.9125 13.8531 14.2656 13.5594 14.5594C13.2656 14.8531 12.9125 15 12.5 15H3.5C3.0875 15 2.73438 14.8531 2.44062 14.5594C2.14687 14.2656 2 13.9125 2 13.5ZM8 11.5L4 7.5L5.05 6.4L7.25 8.6V1H8.75V8.6L10.95 6.4L12 7.5L8 11.5Z"
                        fill="none"
                      />
                    </svg>
                    <span>Download All Data (Email)</span>
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </Grid>
      </Grid>
      {scormReportResponseisLoading && <Loader />}
      {rows?.length === 0 ? (
        <div className="customTableWrapper">
          <NORow />
        </div>
      ) : (
        <div className="customTableWrapper">
          <Table
            columns={finalColumns}
            rows={rows}
            tableRef={tableRef}
            onSort={handleSort}
          />
        </div>
      )}
    </>
  );
};

export default ScormcourseReportList;
